import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.addEventListener("turbo:visit", this.show);
    document.addEventListener("turbo:load", this.hide);
    document.addEventListener("turbo:render", this.hide);
  }

  disconnect() {
    document.removeEventListener("turbo:visit", this.show);
    document.removeEventListener("turbo:load", this.hide);
    document.removeEventListener("turbo:render", this.hide);
  }

  show() {
    document.getElementById("loading-spinner").style.display = "";
  }

  hide() {
    document.getElementById("loading-spinner").style.display = "none";
  }
}